import { render, staticRenderFns } from "./GuidanceReadiness.vue?vue&type=template&id=16048d7e&scoped=true&"
import script from "./GuidanceReadiness.vue?vue&type=script&lang=js&"
export * from "./GuidanceReadiness.vue?vue&type=script&lang=js&"
import style0 from "./GuidanceReadiness.vue?vue&type=style&index=0&id=16048d7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16048d7e",
  null
  
)

export default component.exports